import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { Observable, catchError, map, throwError, timer } from "rxjs";
import { LoadService } from '../services/load.service';
import { AppState } from "../store/reducers";
import { selectSpinnerState } from "../store/reducers/spinners.reducer";

@Injectable()
export class LoadInterceptor implements HttpInterceptor {

  status: boolean;
  constructor(private store: Store<AppState>, private loadService: LoadService) {
    store.select(selectSpinnerState).pipe(takeUntilDestroyed()).subscribe(spinnerState => {
      this.status = spinnerState.status;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Exclude local button spinner with ....Processing text
    let excludeUrls = ["/preview", "/shipping", "/adhoc", "/pdf"];
    let results = excludeUrls.filter(u => req.url.indexOf(u) > -1);
    if (results && results.length == 0) {
      this.loadService.show();
      // if not return in 5s turn off spinner
      this.createDelayUsingTimer(10000).subscribe(v => {
        if (this.status) {
          this.loadService.hide();
        }
      });
    }

    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          this.loadService.hide();
        }
        return event;
      }),
      catchError((e) => {
        this.loadService.hide();
        return throwError(() => e);
      }));
  }

  createDelayUsingTimer(delayValue: number) {
    return timer(delayValue);
  }
}
